import React from 'react'
import { Grid, Typography, Divider } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useNavigate } from 'react-router'
import { contentUrl } from '../../../helpers/url'
import SquareIcon from '@mui/icons-material/Square'
import { contentSlice } from '../../../reducers'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(
  ({ palette, spacing, typography, breakpoints }) => ({
    divider: {
      marginTop: spacing(1)
    },
    title: {
      ...typography.body.l,
      fontWeight: typography.weight.medium,
      color: palette.grey.shade[80]
    },
    icon: {
      width: 10,
      color: palette.grey.shade[10],
      marginRight: spacing(1)
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      paddingTop: spacing(1),
      paddingBottom: spacing(1),
      cursor: 'pointer'
    }
  })
)

const RelatedArticles = (props) => {
  const relatedContent = useSelector(
    contentSlice.selectors.selectRelatedContent
  )
  const { title } = props
  const classes = useStyles()
  const navigate = useNavigate()

  if (!relatedContent.length) {
    return null
  }

  return (
    <Grid item direction='column' data-test='related-articles'>
      <Typography component='h2' className={classes.title}>
        {title}
      </Typography>
      {relatedContent?.map((item, idx) => (
        <div
          key={item?.friendlyUrl ?? idx}
          onClick={() => navigate(contentUrl(item, 'related-articles'))}
          className={classes.item}
        >
          <SquareIcon className={classes.icon} />
          <Typography
            sx={{
              display: '-webkit-box',
              overflow: 'hidden',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2
            }}
          >
            {item.title}
          </Typography>
        </div>
      ))}
      <Divider />
    </Grid>
  )
}

export default RelatedArticles
